export default __webpack_public_path__ + "static/media/(77).0fdcc54c.jpg";